import styled from 'styled-components';

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #ff780c;
  border-radius: 15px;
  width: 100%;
  min-height: 8rem;
  padding: 1rem;
  gap: 0.5rem;
  background-color: #ffffff;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08),
    0 1.5px 4px 0 rgba(0, 0, 0, 0.05);

  break-inside: avoid;
  page-break-inside: avoid;
`;

export const TitleField = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  min-height: 1.5rem;
`;

export const Text = styled.span`
  word-break: break-word;
  white-space: pre-line;
  overflow-wrap: break-word;
  display: block;
  font-family: 'Roboto', sans-serif;
  font-size: clamp(11px, 0.9vw, 14px);
`;

export const AnswerField = styled.div`
  display: flex;
  width: 100%;
  border: 1px solid #d0d1d2;
  border-radius: 10px;
  flex: 1;
  min-height: 4rem;
  padding: 0.75rem;
  background-color: #f4f5f6;
`;
